import React from "react";

import { useTranslator } from "../../context/LanguageContext";

import Navbar from "./Navbar";
import Footer from "./Footer";

const staticNews = [
  { id: 1, image: "n1.jpeg" },
  { id: 2, image: "n2.jpeg" },
  { id: 3, image: "n3.jpeg" },
  { id: 4, image: "n4.jpeg" },
  { id: 5, image: "n5.jpeg" },
  { id: 6, image: "n6.jpeg" },
  { id: 7, image: "n7.jpeg" },
  { id: 8, image: "n8.jpeg" },
  { id: 9, image: "n9.jpeg" },
  { id: 10, image: "n10.jpeg" },
  { id: 11, image: "n11.jpeg" },
  { id: 12, image: "n12.jpeg" },
  { id: 13, image: "n13.jpeg" },
  { id: 14, image: "n14.jpeg" },
  { id: 15, image: "n15.jpeg" },
  { id: 16, image: "n16.jpeg" },
  { id: 17, image: "n17.jpeg" },
  { id: 18, image: "n18.jpeg" },
  { id: 19, image: "n19.jpeg" },
  { id: 20, image: "n20.jpeg" },
  { id: 21, image: "n21.jpeg" },
  { id: 22, image: "n22.jpeg" },
  { id: 23, image: "n23.jpeg" },
  { id: 24, image: "n24.jpeg" },
  { id: 25, image: "n25.jpeg" },
  { id: 26, image: "n27.jpeg" },
  { id: 27, image: "n28.jpeg" },
  { id: 28, image: "n29.jpeg" },
  { id: 29, image: "n30.jpeg" },
  { id: 30, image: "n31.jpeg" },
  { id: 31, image: "n32.jpeg" },
  { id: 32, image: "n33.jpeg" },
  { id: 33, image: "n34.jpeg" },
  { id: 34, image: "n36.jpeg" },
  { id: 35, image: "n37.jpeg" },
  { id: 36, image: "n38.jpeg" },
  { id: 37, image: "n39.jpeg" }
];

const AllNews = () => {

  const { t } = useTranslator();

  const getImageSrc = (image) => {
    if (!image) return null;
    return `${process.env.PUBLIC_URL}/News/${image}`;
  };

  return (
    <>
      <Navbar />

      <style>
        {`

          *{
            margin:0;
            padding:0;
            box-sizing:border-box;
          }

          .all-news-container{
            width:100%;
            min-height:100vh;
            background:#f1f5f9;
            padding:40px 20px;
            font-family:Arial, sans-serif;
          }

          /* =========================
             HEADER
          ========================= */

          .all-news-header{
            text-align:center;
            margin-bottom:40px;
          }

          .all-news-header h1{
            font-size:42px;
            color:#0f172a;
            margin-bottom:10px;
          }

          .all-news-header p{
            color:#64748b;
            font-size:16px;
          }

          /* =========================
             GRID
          ========================= */

          .all-news-grid{
            width:100%;
            display:grid;
            grid-template-columns:
              repeat(auto-fit,minmax(330px,1fr));

            gap:30px;
          }

          /* =========================
             CARD
          ========================= */

          .all-news-card{
            background:white;
            border-radius:20px;
            overflow:hidden;
            box-shadow:
              0 5px 20px rgba(0,0,0,0.08);

            transition:0.3s;
          }

          .all-news-card:hover{
            transform:translateY(-6px);
          }

          /* =========================
             IMAGE
          ========================= */

          .all-news-image{
            width:100%;
            height:240px;
            object-fit:cover;
          }

          /* =========================
             CONTENT
          ========================= */

          .all-news-content{
            padding:22px;
          }

          .all-news-date{
            display:inline-block;
            margin-bottom:12px;
            color:#2563eb;
            font-size:14px;
            font-weight:600;
          }

          .all-news-content h2{
            font-size:24px;
            color:#0f172a;
            margin-bottom:14px;
          }

          .all-news-content p{
            color:#475569;
            line-height:1.7;
            font-size:15px;
          }

          /* =========================
             EMPTY
          ========================= */

          .empty-news{
            width:100%;
            text-align:center;
            padding:80px 20px;
            background:white;
            border-radius:20px;
            box-shadow:
              0 5px 20px rgba(0,0,0,0.08);
          }

          .empty-news h2{
            color:#0f172a;
            margin-bottom:10px;
          }

          .empty-news p{
            color:#64748b;
          }

          /* =========================
             RESPONSIVE
          ========================= */

          @media(max-width:768px){

            .all-news-header h1{
              font-size:30px;
            }

            .all-news-grid{
              grid-template-columns:1fr;
            }

          }

        `}
      </style>

      <div className="all-news-container">

        {/* HEADER */}

        <div className="all-news-header">

          <h1>
            {t("allNews.title")}
          </h1>

          <p>
            {t("allNews.subtitle")}
          </p>

        </div>


        {/* NEWS GRID */}

        {staticNews.length > 0 ? (

          <div className="all-news-grid">

            {staticNews.map((news) => {
              const imageSrc = getImageSrc(news.image);

              return (
                <div
                  className="all-news-card"
                  key={news.id}
                >

                  {imageSrc && (
                    <img
                      src={imageSrc}
                      alt={`News ${news.id}`}
                      className="all-news-image"
                    />
                  )}

                </div>
              );
            })}

          </div>

        ) : (

          <div className="empty-news">

            <h2>
              {t("allNews.emptyTitle")}
            </h2>

            <p>
              {t("allNews.emptyDesc")}
            </p>

          </div>

        )}

      </div>

      <Footer />
    </>
  );
};

export default AllNews;